import { postXeroRequest } from './xeroRequest'

const PRICE_CACHE_TTL_MS = 10 * 60 * 1000

const priceCache = new Map()
const pendingRequests = new Map()

export const getXeroPrice = (code) => {
  const normalizedCode = String(code || '').trim()
  if (!normalizedCode || normalizedCode === 'N/A') {
    return Promise.reject(new Error('A valid Xero code is required'))
  }

  const cached = priceCache.get(normalizedCode)
  if (cached && Date.now() - cached.timestamp < PRICE_CACHE_TTL_MS) {
    return Promise.resolve(cached.response)
  }

  const pending = pendingRequests.get(normalizedCode)
  if (pending) return pending

  const request = postXeroRequest('/api/get_xero_price', { code: normalizedCode })
    .then((response) => {
      priceCache.set(normalizedCode, { response, timestamp: Date.now() })
      return response
    })
    .finally(() => {
      pendingRequests.delete(normalizedCode)
    })

  pendingRequests.set(normalizedCode, request)
  return request
}

export const clearXeroPriceCache = () => {
  priceCache.clear()
}
